// System modules

import { Component, Inject } from '@angular/core';
import { Router , Route, ActivatedRoute} from '@angular/router';
// Custom services
import { AuthService } from '../global_services/auth.service';
import { DebugTerminalService } from '../collection_process/debug_terminal/debug_terminal.service';

// Material components
import { MatSnackBar } from '@angular/material/snack-bar';
import { trigger, state, style, animate, transition, useAnimation } from '@angular/animations';
import { fadeAnimation } from '../animations';
import { ProjectConfigurationService} from '../global_services/project_config.service' ;

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    animations: [
        trigger('changeState', [
            state('original', style({
                opacity: 0
            })),
            transition('* => started', [useAnimation(fadeAnimation, { params: { delay: '800ms' } })])
        ])


    ]
})

export class FooterComponent {

    constructor(public projectConfigurationService: ProjectConfigurationService){
        
    }


}